import React, { Fragment } from "react";

export default (
  <>
    <path d="M22.4124 1.19692C22.2477 1.0514 22.0295 0.981517 21.8111 1.0042L7.88029 2.55205C7.48814 2.59544 7.19141 2.92684 7.19153 3.32132V17.1136C6.49004 16.6938 5.68712 16.4741 4.86969 16.4781C2.73595 16.4782 1 17.8667 1 19.5739C1 21.2812 2.73595 22.6696 4.86964 22.6696C7.00335 22.6696 8.73924 21.2819 8.73924 19.5739V7.8876L21.1222 6.50843V15.5634C20.4205 15.1445 19.6177 14.9255 18.8004 14.9303C16.6667 14.9303 14.9308 16.3187 14.9308 18.0261C14.9308 19.7334 16.6667 21.1218 18.8004 21.1218C20.9341 21.1218 22.67 19.7341 22.67 18.0261V1.77352C22.67 1.5534 22.5763 1.34372 22.4124 1.19692Z" />
  </>
);
